import { Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";
import KeyFeaturesComponent from "@/components/keyFeatures";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const WhyOneMindComponent = () => {
  return (
    <Stack mb={6} w="100%">
      <KeyFeaturesComponent {...WHY_ONEMIND_CONSTANTS} CARD_HEIGHT="210px" />
      <Button
        variant={"ideal"}
        onClick={() => scrollToElement("contact-us", 120)}
        mt={3}
        alignSelf={"center"}
        p={6}
      >
        Ready To Try?
      </Button>
    </Stack>
  );
};

export default WhyOneMindComponent;
